import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-shop-page',
  templateUrl: './shop-page.component.html',
  styleUrls: ['./shop-page.component.scss']
})
export class ShopPageComponent implements OnInit {

  show_ftu: boolean = false;

  constructor(public dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit() {
    try{ window['set_page_name']('shop_page') }catch(e){};

    this.getFtu();
  }

  getFtu() {
    if( !this.dataService.ftu_available ) {
      this.show_ftu = false;
      return;
    }
    const has_seen_ftu = window.localStorage.getItem('has_seen_ftu');
    if (!has_seen_ftu) {
      this.show_ftu = true;
      window.localStorage.setItem('has_seen_ftu', 'true');
    } else {
      this.show_ftu = false;
    }
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/shop-page/shop-page.component.ts